(() => {
  const script = document.currentScript;
  const localizedHeading = script?.dataset.policyHeading;

  if (!localizedHeading) return;

  const updateHeading = () => {
    const heading = document.querySelector('.shopify-policy__title h1');
    if (heading) heading.textContent = localizedHeading;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeading, { once: true });
  } else {
    updateHeading();
  }
})();
